<cm-card>
  <cm-text appearance="emphasis" slot="header">
    {{ baseUrl }}{{ orgUuid }}/members/{{ myUserid }}
  </cm-text>
  <pre><code>{{ data }}</code></pre>
</cm-card>
